export default {
  licenseKey: '843cf208-c799-45be-a0a3-1adb83e8e09c',
};
